import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';

import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { MastersService } from 'src/app/services/masters.service';
import { Login } from '../model/common';
import { map, take, tap, startWith } from 'rxjs/operators';
import { Observable } from 'rxjs';
import Swal from 'sweetalert2';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { LoginService } from '../services/login.service';
declare let $: any;
import { Title } from '@angular/platform-browser';
import { BOL } from '../model/boldata';
import { SystemadminService } from '../services/systemadmin.service';



@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
    title = 'Odak Solutions Pvt Ltd';
    typeSelected: string;
    LoginForm: FormGroup;
    user = '1';
    payload: any = "";
    payloadupdatepermission: any = "";
    payloadcombinepermission: any = "";
    final_list = [];
    ItmesArr = [];
    useridd = "";
    useridmain: any;
    //userpassword: any;
    useridnumber = 0;
    usertype: any;
    CliendID = '';
    dtoken = '';
    tokendata = '';
    token = '';
    tokenid = 0;

    salink: string;
    fflink: string;
    lalink: string;
    fnlink: string;

    useridv = "";
    userpassword = "";
    username = "";
    UserID = "";

    FinYearId: any;
    FinYearDate: any;
    FinId: any;

    windowHeight: number;
    constructor(private router: Router, private route: ActivatedRoute, private sa: SystemadminService, private LService: LoginService,
        private fb: FormBuilder, private titleService: Title) { }
    private allItems: any[];

    ngOnInit() {
        //window.location.reload();
        //window.caches.delete;

        localStorage.clear();
        localStorage.removeItem("FFTokenID");
        localStorage.removeItem("TokenID");
        localStorage.removeItem("FFUserID");
        localStorage.removeItem("FFToken_Access");
        localStorage.removeItem("UserID");

        this.windowHeight = window.innerHeight;
        this.titleService.setTitle(this.title);
        this.createForm();

        localStorage.setItem('SeesionUser', this.user)
        
    }

    createForm() {
        this.LoginForm = this.fb.group({

            Username: '',
            Password: '',

        });
    }

    BindInstanceDtls() {
        this.sa.GetInstanceLinks(this.LoginForm.value).subscribe(data => {
            this.LoginForm.patchValue(data[0]);

            for (var i = 0; i < data.length; i++) {
                if (data[i].TypeID == 531) {
                    this.salink = data[i].Url;
                }
                if (data[i].TypeID == 532) {
                    this.fflink = data[i].Url;
                }
                if (data[i].TypeID == 533) {
                    this.lalink = data[i].Url;
                }
                if (data[i].TypeID == 534) {
                    this.fnlink = data[i].Url;
                }
            }
        });
    }


    BindTokenValues(token, id) {
        this.LoginForm.value.access_token = token;
        this.LoginForm.value.ID = id;
        this.LService.SendToken(this.LoginForm.value).subscribe(data => {


        },
            (error: HttpErrorResponse) => {
                Swal.fire(error.message)
            });
    }
    OnsubmitLogin() {



        var Validation = "";
        if ($('#txtUserName').val() == "") {
            Validation += "please type email id</br>";
        }
        if ($('#txtPassword').val() == "") {
            Validation += "please type Password</br>";
        }
        if (Validation != "") {
            Swal.fire(Validation);
            return;
        }

        //alert($('#txtUserName').val());
        //alert($('#txtPassword').val());
        this.LoginForm.value.User_Idv = $('#txtUserName').val();
        this.LoginForm.value.User_Password = $('#txtPassword').val();
        this.LService.getUserLoginList(this.LoginForm.value).subscribe((data) => {

            if (data.length == 0) {
                Swal.fire("Invalid Credentials");
                return;
            }

            console.log(data, 'loginuserdata')
            this.useridv = data[0].User_Idv;
            this.userpassword = data[0].User_Password;

            this.username = data[0].UserName;
            this.UserID = data[0].UserID;
            localStorage.setItem("UserID", this.UserID.toString());
            localStorage.setItem("UserId", this.UserID.toString());
            console.log(this.UserID,'this.UserID')
            this.LoginForm.value.User_Id = this.UserID;
            this.LService.GetUserActiveValues(this.LoginForm.value).subscribe(res => {
                console.log(res, 'useractive')
                if (res[0]?.User_Active == 2 || res[0]?.Emp_Active_Status == 2) {
                    Swal.fire("User In-Active, Please Contact Administrator");
                    return;
                }
                else {
                    //const currentFYDate = this.getCurrentFinancialYear();
                    const currentFYDate = this.getFinancialYear(4);  // India/UK  → Apr start
                    //const currentFYDate = this.getFinancialYear(7);  // Australia → Jul start
                    //const currentFYDate = this.getFinancialYear(1);  // Germany   → Jan start (calendar year)
                    const currentFYId = this.getFinancialYearId(currentFYDate);

                    let payload1 = {
                        "UserID": parseInt(this.UserID)
                    }
                    this.LService.BindResetFinYearList(payload1).subscribe((data1: any) => {
                        console.log(data1, 'yearchange')
                        if (data1.length > 0) {
                            this.FinId = data1[0].ID;
                            this.FinYearId = data1[0].FinancialYearId;
                            this.FinYearDate = data1[0].FinancialYearDate;

                            let payload = {
                                "ID": this.FinId ? this.FinId : 0,
                                "FinancialYearDate": currentFYDate,
                                "FinancialYearId": currentFYId,
                                "UserID": parseInt(this.UserID),
                            }
                            this.LService.InsertFinYearReset(payload).subscribe((data: any) => {
                                console.log(data, 'bindyearlist')

                            });
                        }
                        else {
                            let payload = {
                                "ID": 0,
                                "FinancialYearDate": currentFYDate,
                                "FinancialYearId": currentFYId,
                                "UserID": parseInt(this.UserID),
                            }
                            this.LService.InsertFinYearReset(payload).subscribe((data: any) => {
                                console.log(data, 'bindyearlist')

                            });
                        }
                    });

                    

                    this.GetTokenFun();

                    //this.GeneratePermission(this.UserID);
                }
            });

            //alert(this.useridv);
            //alert(this.username);
            //alert(this.userpassword);
            //alert(this.UserID);

            

        });
        //this.payload = {
        //    "user_Idv": $('#txtUserName').val(),
        //    "user_Password": $('#txtPassword').val(),
        //}
        //this.LService.getUserLoginList(this.payload).subscribe((res: any) => {
            
        //    const Token = "odakla@2023";
        //    console.log("LoginDetails", res?.data?.logindetails);
        //    console.log("userid", res?.data?.logindetails?.User_Idv);
        //    console.log("LoginDetails", res?.data?.logindetails);
        //    console.log("MainUserID", res?.data?.logindetails?.UserId);
        //    console.log("MainUserPass", res?.data?.logindetails?.User_Password);



           
        //    this.GeneratePermission(res?.data?.logindetails?.UserId);
        //        localStorage.setItem("UserIdv", res?.data?.logindetails?.User_Idv);
        //        localStorage.setItem("UserId", res?.data?.logindetails?.UserId);
        //        localStorage.setItem("UserType", res?.data?.logindetails?.UserType);
        //        localStorage.setItem("Token", Token);
        //        localStorage.setItem("UserID", res?.data?.logindetails?.UserId);
        //        localStorage.setItem("Password", res?.data?.logindetails?.User_Password);
          
            //if ($('#txtUserName').val() == res?.data?.logindetails?.User_Idv) {
              
            //    this.useridd = res?.data?.logindetails?.User_Idv;
               
            //    this.useridmain = res?.data?.logindetails?.UserId;
              
            //    this.usertype = res?.data?.logindetails?.UserType;
            //    this.userpassword = res?.data?.logindetails?.User_Password;
              
            //    this.GeneratePermission(this.useridmain);
            //    localStorage.setItem("UserIdv", res?.data?.logindetails?.User_Idv);
            //    localStorage.setItem("UserId", res?.data?.logindetails?.UserId);
            //    localStorage.setItem("UserType", res?.data?.logindetails?.UserType);
            //    localStorage.setItem("Token", Token);
            //    localStorage.setItem("UserID", res?.data?.logindetails?.UserId);
            //    localStorage.setItem("Password", res?.data?.logindetails?.User_Password);

            


            //}
            //else {
            //    Swal.fire("Invalid Credentials");
            //}


      /*  });*/

        
       
        



    }
    GetTokenFun() {
        this.LService.getToken(this.LoginForm.value).subscribe(data => {


            var strvalues = [];
            var x = 0;
            for (var i in data) {
                if (x == 0) {
                    if (data.hasOwnProperty(i)) {
                        strvalues.push(data[i] + "\n");

                    }
                }
                x++;
            }



            this.dtoken = strvalues.join("");
            this.LoginForm.value.client_id = "FFD";
            this.LoginForm.value.client_secret = "SWRlbnRpdHlAMTIzNDU=";
            this.LoginForm.value.grant_type = "client_credentials";
            this.LoginForm.value.scope = "freightforwardApi.read";
            this.LoginForm.value.UserName = this.username;
            //alert(this.LoginForm.value.UserName);
            this.LoginForm.value.UserID = this.UserID;
            //alert(this.LoginForm.value.UserID);
            this.LoginForm.value.Password = this.userpassword;
            //alert(this.LoginForm.value.Password);
            this.LoginForm.value.response_type = "id_token";
            this.LoginForm.value.access_token = this.dtoken;
            this.LService.SaveAuthentication(this.LoginForm.value).subscribe(data => {

                this.BindTokenValues(data[0].access_token, data[0].ID);

                this.token = data[0].access_token;
                this.tokenid = data[0].ID;
                localStorage.setItem("Token", this.token);
                localStorage.setItem("TokenID", this.tokenid.toString());
                //alert(this.token);
                //alert(this.tokenid);
                //window.location.href = "https://odaksaqa.odaksolutions.in/views/dashboard?Token=" + this.token + "&Token=" + this.tokenid;
                //window.location.href = "https://localhost:44304/views/masters/commonmaster?Token=" + this.token + "&Token=" + this.tokenid;
                //window.location.href = "https://localhost:44306/views/dashboard?Token=" + this.token + "&Token=" + this.tokenid;
                //window.location.href = "https://localhost:44301/views/ladashboards/latransactions/latransactions?Token=" + this.token + "&TokenID=" + this.tokenid;


                

                this.getLandingApplication();
            },
                (error: HttpErrorResponse) => {
                    Swal.fire(error.message)
                });
        });
    }


    //getLandingApplication() {
    //    this.LoginForm.value.UserID = this.UserID;
    //    //alert(this.LoginForm.value.UserID);
    //    this.LService.getLandingApp(this.LoginForm.value).subscribe(data => {
    //        var landAppID = data[0].LandingAppID;
    //        //alert(data[0].LandingAppID);
    //        //alert(landAppID);
    //        console.log(data);

    //        if(landAppID == 2) {
    //            window.location.href = "https://odaklauat.odaksolutions.in/views/ladashboards/latransactions/latransactions?Token=" + this.token + "&TokenID=" + this.tokenid + "&UserID=" + this.UserID;
    //        }
    //        if (landAppID == 3) {
    //            window.location.href = "https://odakffuat.odaksolutions.in/ui/#/main/?Token=" + this.token + "&TokenID=" + this.tokenid + "&UserID=" + this.UserID;
    //        }
    //        if (landAppID == 4) {
    //            window.location.href = "https://odakfnuat.odaksolutions.in/views/finance/financemaster;tabName=transactions?Token=" + this.token + "&TokenID=" + this.tokenid + "&UserID=" + this.UserID;
    //        }
    //        if (landAppID == 5) {
    //            window.location.href = "https://odaksauat.odaksolutions.in/views/dashboard?Token=" + this.token + "&TokenID=" + this.tokenid + "&UserID=" + this.UserID;
    //        }

    //    });
    //}

   
    getLandingApplication() {
        this.LoginForm.value.UserID = this.UserID;
        //alert(this.LoginForm.value.UserID);
        this.LService.getLandingApp(this.LoginForm.value).subscribe(data => {
            var landAppID = data[0].LandingAppID;
            //alert(data[0].LandingAppID);
            //alert(landAppID);
            console.log(data);

            if(landAppID == 2) {
                window.location.href = "https://la-navioindia.freighteiz.com/views/ladashboards/latransactions/latransactions?Token=" + this.token + "&TokenID=" + this.tokenid + "&UserID=" + this.UserID;
            }
            if (landAppID == 3) {
                window.location.href = "https://ff-navioindia.freighteiz.com/ui/#/main?Token=" + this.token + "&TokenID=" + this.tokenid + "&UserID=" + this.UserID;
            }
            if (landAppID == 4) {
                window.location.href = "https://fn-navioindia.freighteiz.com/views/finance/financemaster;tabName=transactions?Token=" + this.token + "&TokenID=" + this.tokenid + "&UserID=" + this.UserID;
            }
            if (landAppID == 5) {
                window.location.href = "https://sa-navioindia.freighteiz.com/views/dashboard?Token=" + this.token + "&TokenID=" + this.tokenid + "&UserID=" + this.UserID;
            }

        });
    }

    //getLandingApplication() {
    //    this.LoginForm.value.UserID = this.UserID;
    //    //alert(this.LoginForm.value.UserID);
    //    this.LService.getLandingApp(this.LoginForm.value).subscribe(data => {
    //        var landAppID = data[0].LandingAppID;
    //        //alert(data[0].LandingAppID);
    //        //alert(landAppID);
    //        console.log(data);

    //        if(landAppID == 2) {
    //            window.location.href = "https://la-skib.freighteiz.com/views/ladashboards/latransactions/latransactions?Token=" + this.token + "&TokenID=" + this.tokenid + "&UserID=" + this.UserID;
    //        }
    //        if (landAppID == 3) {
    //            window.location.href = "https://ff-skib.freighteiz.com/ui/#/main?Token=" + this.token + "&TokenID=" + this.tokenid + "&UserID=" + this.UserID;
    //        }
    //        if (landAppID == 4) {
    //            window.location.href = "https://fn-skib.freighteiz.com/views/finance/financemaster;tabName=transactions?Token=" + this.token + "&TokenID=" + this.tokenid + "&UserID=" + this.UserID;
    //        }
    //        if (landAppID == 5) {
    //            window.location.href = "https://sa-skib.freighteiz.com/views/dashboard?Token=" + this.token + "&TokenID=" + this.tokenid + "&UserID=" + this.UserID;
    //        }

    //    });
    //}

    //getLandingApplication() {
    //    this.LoginForm.value.UserID = this.UserID;
    //    //alert(this.LoginForm.value.UserID);
    //    this.LService.getLandingApp(this.LoginForm.value).subscribe(data => {
    //        var landAppID = data[0].LandingAppID;
    //        //alert(data[0].LandingAppID);
    //        //alert(landAppID);
    //        console.log(data);

    //        if(landAppID == 2) {
    //            window.location.href = "https://la-nikins.freighteiz.com/views/ladashboards/latransactions/latransactions?Token=" + this.token + "&TokenID=" + this.tokenid + "&UserID=" + this.UserID;
    //        }
    //        if (landAppID == 3) {
    //            window.location.href = "https://ff-nikins.freighteiz.com/ui/#/main?Token=" + this.token + "&TokenID=" + this.tokenid + "&UserID=" + this.UserID;
    //        }
    //        if (landAppID == 4) {
    //            window.location.href = "https://fn-nikins.freighteiz.com/views/finance/financemaster;tabName=transactions?Token=" + this.token + "&TokenID=" + this.tokenid + "&UserID=" + this.UserID;
    //        }
    //        if (landAppID == 5) {
    //            window.location.href = "https://sa-nikins.freighteiz.com/views/dashboard?Token=" + this.token + "&TokenID=" + this.tokenid + "&UserID=" + this.UserID;
    //        }

    //    });
    //}

    //getLandingApplication() {
    //    this.LoginForm.value.UserID = this.UserID;
    //    //alert(this.LoginForm.value.UserID);
    //    this.LService.getLandingApp(this.LoginForm.value).subscribe(data => {
    //        var landAppID = data[0].LandingAppID;
    //        //alert(data[0].LandingAppID);
    //        //alert(landAppID);
    //        console.log(data);

    //        if(landAppID == 2) {
    //            window.location.href = "https://la-naviouat.freighteiz.com/views/ladashboards/latransactions/latransactions?Token=" + this.token + "&TokenID=" + this.tokenid + "&UserID=" + this.UserID;
    //        }
    //        if (landAppID == 3) {
    //            window.location.href = "https://ff-naviouat.freighteiz.com/ui/#/main?Token=" + this.token + "&TokenID=" + this.tokenid + "&UserID=" + this.UserID;
    //        }
    //        if (landAppID == 4) {
    //            window.location.href = "https://fn-naviouat.freighteiz.com/views/finance/financemaster;tabName=transactions?Token=" + this.token + "&TokenID=" + this.tokenid + "&UserID=" + this.UserID;
    //        }
    //        if (landAppID == 5) {
    //            window.location.href = "https://sa-naviouat.freighteiz.com/views/dashboard?Token=" + this.token + "&TokenID=" + this.tokenid + "&UserID=" + this.UserID;
    //        }

    //    });
    //}


    getCurrentFinancialYear(): string {
        const today = new Date();
        const month = today.getMonth() + 1;
        const year = today.getFullYear();
        const startYear = month >= 4 ? year : year - 1;
        const endYear = (startYear + 1).toString().slice(-2);
        return `${startYear}-${endYear}`; // e.g. "2025-26"
    }

    getFinancialYear(fyStartMonth: number = 4): string {
        const today = new Date();
        const month = today.getMonth() + 1;
        const year = today.getFullYear();

        const startYear = month >= fyStartMonth ? year : year - 1;
        const endYear = (startYear + 1).toString().slice(-2);
        return `${startYear}-${endYear}`;
    }

    getFinancialYearId(fyDate: string): number {
        const BASE_YEAR = 2013;
        const BASE_ID = 1;
        const startYear = parseInt(fyDate.split('-')[0]);
        return BASE_ID + (startYear - BASE_YEAR);
    }

    GeneratePermission(userid: any) {
        let payload3 = {
            "isdata": "G",
            "ref_RoleId": "",
            "UserId": userid,
            "Created_by": 0
        }
        console.log("GeneratePayload", payload3);
        this.LService.GenerateUserPermissionObject(payload3).subscribe(res => {
            if (res.statuscode == 200 && res.message == "Success") {
                this.GeneratePermissionupdate(userid);
            }

        });
    }
    GeneratePermissionupdate(userid: any) {
        this.payloadupdatepermission = {
            "userId": userid
        }
        this.LService.getUserPermissionUpdateList(this.payloadupdatepermission).subscribe((res: any) => {

            if (res.statuscode == 200 && res.message == "Success") {
                this.GeneratePermissionCombined(parseInt(userid));
            }

        });
    }
    GeneratePermissionCombined(userid: any) {

        let numberValue = Number(localStorage.getItem("UserId"));


        let payload2 = {

            "userId": userid

        }

        console.log("payloadcombined", payload2)
        this.LService.getUserPermissionCombinedList(payload2).subscribe((res: any) => {


        });
    }

    OnsubmitOverlay() {
        /* $('#overlay').fadeIn().delay(2000).fadeOut();*/

    }
    //userAuthentication(userName, password) {

    //    var data = {
    //        Username: userName,
    //        Password: password,
    //        grant_type: "password"
    //    };
    //    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/json', 'No-Auth': 'True' });
    //    return this.http.post(this.globals.APIURL + '/users/authenticate', data, { headers: reqHeader });
    //}

}

